import { render, staticRenderFns } from "./StudentBadges.vue?vue&type=template&id=6b885194&scoped=true&"
import script from "./StudentBadges.vue?vue&type=script&lang=js&"
export * from "./StudentBadges.vue?vue&type=script&lang=js&"
import style0 from "./StudentBadges.vue?vue&type=style&index=0&id=6b885194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b885194",
  null
  
)

export default component.exports